<script>
  import QrCode from '$lib/assets/images/qrcode.jpg';
</script>

<div class="w-36">
  <img src={QrCode} alt="QrCode" />
  <p class="mt-1 text-sm text-center">关注公众号</p>
</div>
